import React from "react";
import Chart from 'chart.js';
import {
  Row, Col, Card, CardHeader,
  CardBody, InputGroup,
  Button, Label
} from "reactstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { GetTypeOperatorList } from '../../api/ProductTypeOperatorApi'
import { GetProductTypeList } from "../../api/ProductType";
import classNames from "classnames";


class ProductTypeOperator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      data: [],
      chartData: null,

      startDate: this.props.DataFromDashboard.selectedStartDate,
      endDate: this.props.DataFromDashboard.selectedEndDate,
      operator: this.props.DataFromDashboard.paramOperator,
      productType: this.props.DataFromDashboard.paramType,
      DefaultproductTypeList: [],
      companyId: this.props.DataFromDashboard.companyId,
      userId: this.props.DataFromDashboard.userId,
      roleId: this.props.DataFromDashboard.roleId
    }

    this.canvasRef = React.createRef();
    this.colorArray = ['lime', 'teal', 'aqua', 'fuchsia', 'yellow', 'red', 'maroon', 'purple', 'lightblue', 'lightgreen', 'pink'];

  }



  bindData() {
    const { data } = this.state;
    let operatorNameArry = [];
    let typeNameArry = [];

    data.forEach((item) => {
      if (!operatorNameArry.includes(item.operatorName)) {
        operatorNameArry.push(item.operatorName);
      }
      typeNameArry.push(item.typeName);
    });
    const maxOperatorNameLength = operatorNameArry.length;
    let defaultData = new Array(maxOperatorNameLength).fill(0);

    this.setState({ chartData: { ...this.state.chartData, labels: operatorNameArry } });

    let DataSetAry = new Array(this.state.DefaultproductTypeList.length);
    for (let i = 0; i < this.state.DefaultproductTypeList.length; i++) {
      DataSetAry[i] =
      {
        label: this.state.DefaultproductTypeList[i].typeName,
        backgroundColor: this.colorArray[i],
        borderColor: "rgba(0,123,255,1)",
        pointBackgroundColor: "#ffffff",
        pointHoverBackgroundColor: "rgb(0,123,255)",
        borderWidth: 1.5,
        pointRadius: 0,
        pointHoverRadius: 5,

        data: defaultData.slice(0, operatorNameArry.length),
      };
    }
    for (let i = 0; i < data.length; i++) {

      const typeName = data[i].typeName;
      const operatorName = data[i].operatorName;
      const sellPrice = data[i].sellPrice;

      const typeIndex = typeNameArry.indexOf(typeName);
      const operatorIndex = operatorNameArry.indexOf(operatorName);

      if (typeIndex >= 0 && operatorIndex >= 0) {
        const typeObjectIndex = DataSetAry.findIndex(({ label }) => label === typeName);
        DataSetAry[typeObjectIndex].data[operatorIndex] += sellPrice;
      }
    }

    this.setState({ chartData: { ...this.state.chartData, datasets: DataSetAry } });

  }


  async componentDidMount() {
    const resdata = await GetTypeOperatorList(this.state);
    const typeList = await GetProductTypeList(this.state.companyId);
    this.setState({ data: resdata, DefaultproductTypeList: typeList.sort((a, b) => a.typeName.localeCompare(b.typeName)) });
    this.bindData();
    if (this.state.data.length !== 0) {
      const chartOptions = {
        ...{
          responsive: true,
          legend: {
            position: "top"
          },
          title: {
            display: false,
            text: 'Trans'
          },
          hover: {
            mode: "nearest",
            intersect: false
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return `${datasetLabel}: ${value.toLocaleString('en')}`;
              }
            }
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  precision: 0,
                  callback: function (value, index, values) {
                    return value.toLocaleString('en');
                  }
                }
              }
            ]
          }
        },
      };
      const BlogUsersOverview = new Chart(this.canvasRef.current, {
        type: 'bar',
        data: this.state.chartData,
        options: chartOptions
      });

      BlogUsersOverview.render();
    }
  }

  updateState(prop, value) {
    this.setState({ [prop]: value });
  }

  render() {
    const classes = classNames("d-flex", "my-auto", "date-range");
    return (
      <Card small className="h-100">
        <CardHeader className="border-bottom">
          <h6 className="m-0">Product Type and Operator</h6>
        </CardHeader>
        <CardBody className="pt-0">
          {this.state.data.length === 0 ?
            (
              <div className="m-auto text-muted" style={{
                fontSize: '1.2rem', height: '200px', padding: '20px', margin: '10px',
                display: 'flex', justifyContent: 'center', alignItems: 'center'
              }}>
                No Data
              </div>
            ) : (
              <canvas
                height="150"
                ref={this.canvasRef}
                style={{ maxWidth: "100% !important" }}
              />
            )
          }
        </CardBody>
      </Card>
    );
  }
}


export default ProductTypeOperator;